import { render, staticRenderFns } from "./StatData.vue?vue&type=template&id=4612ed14&"
import script from "./StatData.vue?vue&type=script&lang=js&"
export * from "./StatData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports